import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormGroupProps,
  FormHelperText,
  SwitchProps,
} from "@mui/material";
import { FieldTitle, useInput } from "ra-core";
import * as React from "react";
import { useCallback } from "react";
import {
  CommonInputProps,
  InputHelperText,
  sanitizeInputRestProps,
} from "react-admin";

export type CheckboxInputProps = CommonInputProps &
  SwitchProps &
  Omit<FormGroupProps, "defaultValue" | "onChange" | "onBlur" | "onFocus"> & {
    options?: SwitchProps;
  };

export default function CheckboxInput(props: CheckboxInputProps) {
  const {
    className,
    row = false,
    defaultValue = false,
    format,
    label,
    fullWidth,
    helperText,
    onBlur,
    onChange,
    onFocus,
    disabled,
    parse,
    resource,
    source,
    validate,
    options,
    sx,
    ...rest
  } = props;
  const {
    id,
    field,
    isRequired,
    fieldState: { error, invalid, isTouched },
    formState: { isSubmitted },
  } = useInput({
    defaultValue,
    format,
    parse,
    resource,
    source,
    onBlur,
    onChange,
    type: "checkbox",
    validate,
    ...rest,
  });

  const handleChange = useCallback(
    (event) => {
      field.onChange(event);
      // Ensure field is considered as touched
      field.onBlur();
    },
    [field]
  );

  return (
    <FormGroup
      className={`ra-input ra-input-${source} ${className}`}
      row={row}
      sx={sx}
    >
      <FormControlLabel
        control={
          <Checkbox
            id={id}
            name={field.name}
            color="primary"
            onChange={handleChange}
            onFocus={onFocus}
            checked={field.value}
            {...sanitizeInputRestProps(rest)}
            {...options}
            disabled={disabled}
          />
        }
        label={
          <FieldTitle
            label={label}
            source={source}
            resource={resource}
            isRequired={isRequired}
          />
        }
      />
      <FormHelperText error={(isTouched || isSubmitted) && invalid}>
        <InputHelperText
          touched={isTouched || isSubmitted}
          error={error?.message}
          helperText={helperText}
        />
      </FormHelperText>
    </FormGroup>
  );
}
